import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"10px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"20px","display":"flex","flex-direction":"row"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px","width":"3px","background":"#55acee"} }),
  /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"20px","margin-left":"5px","font-size":"16px","font-weight":"300"} }, "电子书统计")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  id: "main",
  style: {"width":"100%","height":"300px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_like_outlined = _resolveComponent("like-outlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_arrow_down_outlined = _resolveComponent("arrow-down-outlined")!
  const _component_arrow_up_outlined = _resolveComponent("arrow-up-outlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "总阅读量",
                          value: _ctx.ebookStatistic.viewCount
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_UserOutlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "总点赞量",
                          value: _ctx.ebookStatistic.voteCount
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_like_outlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "点赞率",
                          value: _ctx.ebookStatistic.voteCount / _ctx.ebookStatistic.viewCount * 100,
                          precision: 2,
                          suffix: "%",
                          "value-style": { color: '#cf1322' }
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_like_outlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "今日阅读",
                          value: _ctx.ebookStatistic.todayViewCount,
                          style: {"margin-right":"50px"}
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_UserOutlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "今日点赞",
                          value: _ctx.ebookStatistic.todayVoteCount
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_like_outlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "预计今日阅读",
                          value: _ctx.ebookStatistic.todayViewIncrease,
                          "value-style": { color: '#0000ff' }
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_UserOutlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "预计今日阅读增长",
                          value: _ctx.ebookStatistic.todayViewIncreaseRateAbs,
                          precision: 2,
                          suffix: "%",
                          class: "demo-class",
                          "value-style": _ctx.ebookStatistic.todayViewIncreaseRate < 0 ? { color: '#3f8600' } : { color: '#cf1322' }
                        }, {
                          prefix: _withCtx(() => [
                            (_ctx.ebookStatistic.todayViewIncreaseRate < 0)
                              ? (_openBlock(), _createBlock(_component_arrow_down_outlined, { key: 0 }))
                              : _createCommentVNode("", true),
                            (_ctx.ebookStatistic.todayViewIncreaseRate >= 0)
                              ? (_openBlock(), _createBlock(_component_arrow_up_outlined, { key: 1 }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["value", "value-style"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_4,
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_card, { style: { width: '100%' } }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              span: 24,
              id: "main-col"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}